import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.5",
  "description": "Sidecar tasks, `--continue` flexibility, turbo.jsonc, Bun pruning, `$TURBO_ROOT$`, OpenAPI viewer, and more.",
  "date": "2025/4/3",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "turborepo-25",
    "content": "Turborepo 2.5 includes a number of improvements to enhance your repository:"
  }, {
    "heading": "turborepo-25",
    "content": "Sidecar tasks: Use with to ensure persistent tasks always run together"
  }, {
    "heading": "turborepo-25",
    "content": "Flexibility for --continue: Only continue running tasks when dependencies are successful"
  }, {
    "heading": "turborepo-25",
    "content": "turbo.jsonc: Write comments directly in your configuration file"
  }, {
    "heading": "turborepo-25",
    "content": "prune for Bun: You can now use turbo prune in Bun repositories"
  }, {
    "heading": "turborepo-25",
    "content": "$TURBO_ROOT$: Reference the Workspace root in turbo.json"
  }, {
    "heading": "turborepo-25",
    "content": "OpenAPI viewer: Human-readable OpenAPI spec for self-hosted Remote Caches"
  }, {
    "heading": "turborepo-25",
    "content": "Upgrade today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "sidecar-tasks",
    "content": "In some cases, you want to ensure two long-running tasks are always running at the same time. For example, you may have a web application that makes requests to another application in your monorepo. Running the web application by itself may not be useful, since the backend API application won’t be available to serve its requests."
  }, {
    "heading": "sidecar-tasks",
    "content": "You may have tried to use dependsOn to create this relationship - but quickly discovered that depending on a long-running task isn’t allowed. A long-running task never exits, so the dependent task would never run. This meant you’d have to carefully craft a --filter to ensure those resources are available—and make sure everyone in the repo knows to use it."
  }, {
    "heading": "sidecar-tasks",
    "content": "Instead, we’re introducing the with key so you can guarantee that a dependent long-running task always runs with the long-running tasks that it depends on at runtime."
  }, {
    "heading": "sidecar-tasks",
    "content": "Using this Package Configuration, anytime that the web application’s dev task is started, the api's start task will also run using the package#task microsyntax."
  }, {
    "heading": "sidecar-tasks",
    "content": "Visit the documentation to learn more."
  }, {
    "heading": "improved-control-for---continue-behavior",
    "content": "By default, Turborepo stops running tasks when it encounters a task that has failed. You can alter this behavior using the --continue flag, instructing Turborepo to continue running tasks, even when one or more tasks have failed."
  }, {
    "heading": "improved-control-for---continue-behavior",
    "content": "While the --continue flag is useful, there are times when running tasks whose dependencies have failed will only result in more failures. For these situations, we’ve added a new value to the --continue flag in this release: --continue=dependencies-successful."
  }, {
    "heading": "improved-control-for---continue-behavior",
    "content": "When using this value, all dependencies for a task must be successful for the dependent task to run."
  }, {
    "heading": "improved-control-for---continue-behavior",
    "content": "Learn more in the documentation."
  }, {
    "heading": "improved-control-for---continue-behavior",
    "content": "The Turborepo core team would like to thank @jenseng for contributing this feature."
  }, {
    "heading": "add-comments-to-your-turborepo-configuration-files",
    "content": "You can now use JSONC (turbo.jsonc) for your configuration files, allowing you to add useful comments to your configuration."
  }, {
    "heading": "pruned-monorepos-for-bun-repositories",
    "content": "turbo prune creates a partial monorepo for a target package, and is especially useful for creating lightweight Docker images from monorepos. This command has been available for pnpm, npm, and Yarn repositories in previous versions of Turborepo."
  }, {
    "heading": "pruned-monorepos-for-bun-repositories",
    "content": "In this release, turbo prune is now available for Bun v1.2+, which has introduced a text-based lockfile that we can now read and analyze."
  }, {
    "heading": "pruned-monorepos-for-bun-repositories",
    "content": "To learn more about turbo prune, visit the documentation."
  }, {
    "heading": "pruned-monorepos-for-bun-repositories",
    "content": "The Turborepo core team would like to thank @camero2734 for contributing this feature."
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "In some situations, you’re forced to break out of package boundaries in a monorepo. This could be due to a number of constraints, like tooling that doesn’t conform to modern package manager workspaces or incremental migration workflows that take you out of ideal conditions."
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "In the past, you’d need to write paths in turbo.json that traverse to the workspace root, since globs are anchored to the root of packages:"
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "While this pattern does work, it can lead to inconsistencies in some cases:"
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "Some packages may need ../ while others need ../../"
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "A developer could potentially move a package to a different location so that the path isn’t correct"
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "Instead, you can now use the $TURBO_ROOT$ microsyntax:"
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "Now, this file glob is guaranteed to always start at the root of your workspace."
  }, {
    "heading": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "Visit the documentation to learn more."
  }, {
    "heading": "openapi-specification-viewer-for-self-hosting",
    "content": "Turborepo is proudly open-source with a public specification for its Remote Caching protocol. While Vercel Remote Cache is a free-to-use managed option, the OpenAPI spec allows the community to create implementations for Remote Caching of their own."
  }, {
    "heading": "openapi-specification-viewer-for-self-hosting",
    "content": "We’ve published the Remote Cache spec as JSON to the web for some time, and have recently added a human-friendly version of the spec at https://turborepo.com/docs/openapi."
  }, {
    "heading": "openapi-specification-viewer-for-self-hosting",
    "content": "Visit the Remote Caching documentation to learn more."
  }, {
    "heading": "other-changes",
    "content": "feat(boundaries): package rules (#10160)"
  }, {
    "heading": "other-changes",
    "content": "feat(boundaries): package name as tag punning (#10151)"
  }, {
    "heading": "other-changes",
    "content": "feat(boundaries): implicit dependencies (#10117)"
  }, {
    "heading": "other-changes",
    "content": "feat(process): distinguish between signals used to kill children (#10049)"
  }, {
    "heading": "other-changes",
    "content": "feat(boundaries): auto ignore (#10147)"
  }, {
    "heading": "other-changes",
    "content": "feat(clone): turbo clone (#9904)"
  }, {
    "heading": "other-changes",
    "content": "feat(boundaries): support tsconfig path aliases (#10002)"
  }, {
    "heading": "other-changes",
    "content": "feat(query): add schema flag (#10052)"
  }, {
    "heading": "other-changes",
    "content": "feat(ls): add package path to ls (#10079)"
  }, {
    "heading": "other-changes",
    "content": "fix(turbo_json): avoid workspace validation errors (#10211)"
  }, {
    "heading": "other-changes",
    "content": "fix(bun): deserialize correctly and use optionalPeers (#10219)"
  }, {
    "heading": "other-changes",
    "content": "fix: update env variables supported by nitro (#10176)"
  }, {
    "heading": "other-changes",
    "content": "fix: mark type of flat config export to satisfy Linter.Config[] (#10128)"
  }, {
    "heading": "other-changes",
    "content": "fix(eslint): array type lints (#10139)"
  }, {
    "heading": "other-changes",
    "content": "fix(bun): properly handle bun lockfile keys (#10137)"
  }, {
    "heading": "other-changes",
    "content": "fix: eslint-config-turbo module export (#10105)"
  }, {
    "heading": "other-changes",
    "content": "fix: correctly forward passthrough arguments when using pkg#task format (#10087)"
  }, {
    "heading": "other-changes",
    "content": "fix(boundaries): support import attributes (#10078)"
  }, {
    "heading": "other-changes",
    "content": "fix(boundaries): unnecessary tsconfig warnings (#10104)"
  }, {
    "heading": "other-changes",
    "content": "fix(affected): consider turbo.jsonc as a default global dependency (#10106)"
  }, {
    "heading": "other-changes",
    "content": "fix(prune): support copying turbo.jsonc (#10107)"
  }, {
    "heading": "other-changes",
    "content": "fix(cli): no longer attempt to parse task name as continue value (#10097)"
  }, {
    "heading": "other-changes",
    "content": "fix: affected_packages's optimization flow (#9950)"
  }, {
    "heading": "other-changes",
    "content": "fix(@turbo/repository): revert \"chore(deps): update git2 to 0.20.0\" (#10045)"
  }, {
    "heading": "other-changes",
    "content": "fix(process): revert \"feat(process): differentiate between child interruption and killing\" (#10046)"
  }, {
    "heading": "other-changes",
    "content": "fix: filter logic (#9653)"
  }, {
    "heading": "other-changes",
    "content": "fix(packages): no longer match versionless packages (#10056)"
  }, {
    "heading": "other-changes",
    "content": "fix(engine): no longer error if provided task is omitted by filter (#10051)"
  }, {
    "heading": "other-changes",
    "content": "docs: layout redesign (#10178)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix text colors in a few spots (#10213)"
  }, {
    "heading": "other-changes",
    "content": "docs: remove stale callout (#10217)"
  }, {
    "heading": "other-changes",
    "content": "docs: links for OpenAPI spec for both human-readable and JSON (#10216)"
  }, {
    "heading": "other-changes",
    "content": "docs: add a snippet to with (#10215)"
  }, {
    "heading": "other-changes",
    "content": "docs: mention JSONC support (#10214)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix the incorrect export keyword (#10235)"
  }, {
    "heading": "other-changes",
    "content": "docs: add checkout optimization for --affected (#10188)"
  }, {
    "heading": "other-changes",
    "content": "docs: use schema from current @turbo/types (#10197)"
  }, {
    "heading": "other-changes",
    "content": "docs: switch turbo run to turbo watch for --experimental-write-cache (#10199)"
  }, {
    "heading": "other-changes",
    "content": "docs(run): fix passthrough arg behavior (#10167)"
  }, {
    "heading": "other-changes",
    "content": "docs: bump openapi framework version (#10172)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix typos (#10182)"
  }, {
    "heading": "other-changes",
    "content": "docs: update fallback OG image (#10174)"
  }, {
    "heading": "other-changes",
    "content": "docs: enhance examples tables (#10173)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix typos in documentation files (#10192)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix typos in documentation files (#10124)"
  }, {
    "heading": "other-changes",
    "content": "docs: update storybook initiation instructions (#10145)"
  }, {
    "heading": "other-changes",
    "content": "docs: clarify TURBO_TEAM slug usage (#10102)"
  }, {
    "heading": "other-changes",
    "content": "fix: adds callout for installation instructions for PNPM (#10100)"
  }, {
    "heading": "other-changes",
    "content": "docs: add release phases to support policy (#10091)"
  }, {
    "heading": "other-changes",
    "content": "docs: remove ls from Experimental phase in Support Policy (#10108)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix code black background colors (#10141)"
  }, {
    "heading": "other-changes",
    "content": "fix(docs): prefix environment variable for search dialog (#10142)"
  }, {
    "heading": "other-changes",
    "content": "fix(docs): fix commas in package exports example (#10143)"
  }, {
    "heading": "other-changes",
    "content": "docs: open source site source code (#10127)"
  }, {
    "heading": "other-changes",
    "content": "docs: remove experimental warning from ls command (#10096)"
  }, {
    "heading": "other-changes",
    "content": "docs: add hybrid approach to vitest guide (#10092)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix typo on continue docs (#10041)"
  }, {
    "heading": "other-changes",
    "content": "docs: add explicit mention for capturing multiple .env files (#10061)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix json title for Watch Mode docs (#10085)"
  }, {
    "heading": "other-changes",
    "content": "docs: upgrades for Vitest doc and add with-vitest example (#10063)"
  }, {
    "heading": "other-changes",
    "content": "fix(docs): asset importing failure for OG images (#10159)"
  }, {
    "heading": "other-changes",
    "content": "fix: unexpected top-level property default in base.js eslint config (#10240)"
  }, {
    "heading": "other-changes",
    "content": "fix(example): remove obsolete @types/react-native from with-react-native-web (#10190)"
  }, {
    "heading": "other-changes",
    "content": "docs: update README.md in examples with-tailwind to correctly reference .ts config files instead of .js (#10057)"
  }, {
    "heading": "other-changes",
    "content": "docs: fix JSDoc annotation for ESLint flat configs of basic example (#10089)"
  }, {
    "heading": "other-changes",
    "content": "feat(examples): add example with-solid (#10144)"
  }, {
    "heading": "acknowledgments-and-community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team: Anthony, Chris, Dimitri, Nicholas, and Tom."
  }, {
    "heading": "acknowledgments-and-community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. To learn how to get involved, visit the Community page."
  }, {
    "heading": "acknowledgments-and-community",
    "content": "We also thank everyone who contributed to this release of Turborepo: @beaussan, @bohongu, @camero2734, @cprussin, @dinglindong, @jenseng, @jimmycathy, @kevincatty, @mm-webx, @ognevny, @pi0, @pudongair, @rootdiae, @shinjith-dev, @sicarius97, @ssshashank, @Tigatok, @todaymoon, @Tyoneb, @victorlagerfors, @vinayaksodar, @wmjae, @x-N0, and @xiaobei0715."
  }],
  "headings": [{
    "id": "turborepo-25",
    "content": "Turborepo 2.5"
  }, {
    "id": "sidecar-tasks",
    "content": "Sidecar tasks"
  }, {
    "id": "improved-control-for---continue-behavior",
    "content": "Improved control for --continue behavior"
  }, {
    "id": "add-comments-to-your-turborepo-configuration-files",
    "content": "Add comments to your Turborepo configuration files"
  }, {
    "id": "pruned-monorepos-for-bun-repositories",
    "content": "Pruned monorepos for Bun repositories"
  }, {
    "id": "reference-your-workspace-root-with-the-turbo_root-microsyntax",
    "content": "Reference your workspace root with the $TURBO_ROOT$ microsyntax"
  }, {
    "id": "openapi-specification-viewer-for-self-hosting",
    "content": "OpenAPI specification viewer for self-hosting"
  }, {
    "id": "other-changes",
    "content": "Other changes"
  }, {
    "id": "acknowledgments-and-community",
    "content": "Acknowledgments and community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Accordion, Accordions} from '#components/accordion';
export const toc = [{
  depth: 1,
  url: "#turborepo-25",
  title: _jsx(_Fragment, {
    children: "Turborepo 2.5"
  })
}, {
  depth: 2,
  url: "#sidecar-tasks",
  title: _jsx(_Fragment, {
    children: "Sidecar tasks"
  })
}, {
  depth: 2,
  url: "#improved-control-for---continue-behavior",
  title: _jsxs(_Fragment, {
    children: ["Improved control for ", _jsx("code", {
      children: "--continue"
    }), " behavior"]
  })
}, {
  depth: 2,
  url: "#add-comments-to-your-turborepo-configuration-files",
  title: _jsx(_Fragment, {
    children: "Add comments to your Turborepo configuration files"
  })
}, {
  depth: 2,
  url: "#pruned-monorepos-for-bun-repositories",
  title: _jsx(_Fragment, {
    children: "Pruned monorepos for Bun repositories"
  })
}, {
  depth: 2,
  url: "#reference-your-workspace-root-with-the-turbo_root-microsyntax",
  title: _jsxs(_Fragment, {
    children: ["Reference your workspace root with the ", _jsx("code", {
      children: "$TURBO_ROOT$"
    }), " microsyntax"]
  })
}, {
  depth: 2,
  url: "#openapi-specification-viewer-for-self-hosting",
  title: _jsx(_Fragment, {
    children: "OpenAPI specification viewer for self-hosting"
  })
}, {
  depth: 2,
  url: "#other-changes",
  title: _jsx(_Fragment, {
    children: "Other changes"
  })
}, {
  depth: 2,
  url: "#acknowledgments-and-community",
  title: _jsx(_Fragment, {
    children: "Acknowledgments and community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      id: "turborepo-25",
      children: "Turborepo 2.5"
    }), "\n", _jsx(Date, {
      children: "Thursday, April 3rd, 2025"
    }), "\n", _jsx(Authors, {
      authors: ['nicholasyang', 'anthonyshew', 'chrisolszewski']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.5 includes a number of improvements to enhance your repository:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#sidecar-tasks",
          children: _jsx(_components.strong, {
            children: "Sidecar tasks"
          })
        }), ": Use ", _jsx(_components.code, {
          children: "with"
        }), " to ensure persistent tasks always run together"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-control-for---continue-behavior",
          children: _jsxs(_components.strong, {
            children: ["Flexibility for ", _jsx(_components.code, {
              children: "--continue"
            })]
          })
        }), ": Only continue running tasks when dependencies are successful"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#add-comments-to-your-turborepo-configuration-files",
          children: _jsx(_components.strong, {
            children: _jsx(_components.code, {
              children: "turbo.jsonc"
            })
          })
        }), ": Write comments directly in your configuration file"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#pruned-monorepos-for-bun-repositories",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "prune"
            }), " for Bun"]
          })
        }), ": You can now use ", _jsx(_components.code, {
          children: "turbo prune"
        }), " in Bun repositories"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#reference-your-workspace-root-with-the-turbo_root-microsyntax",
          children: _jsx(_components.strong, {
            children: _jsx(_components.code, {
              children: "$TURBO_ROOT$"
            })
          })
        }), ": Reference the Workspace root in ", _jsx(_components.code, {
          children: "turbo.json"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#openapi-specification-viewer-for-self-hosting",
          children: _jsx(_components.strong, {
            children: "OpenAPI viewer"
          })
        }), ": Human-readable OpenAPI spec for self-hosted Remote Caches"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Upgrade today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "sidecar-tasks",
      children: "Sidecar tasks"
    }), "\n", _jsx(_components.p, {
      children: "In some cases, you want to ensure two long-running tasks are always running at the same time. For example, you may have a web application that makes requests to another application in your monorepo. Running the web application by itself may not be useful, since the backend API application won’t be available to serve its requests."
    }), "\n", _jsxs(_components.p, {
      children: ["You may have tried to use ", _jsx(_components.code, {
        children: "dependsOn"
      }), " to create this relationship - but quickly discovered that depending on a long-running task isn’t allowed. A long-running task never exits, so the dependent task would never run. This meant you’d have to carefully craft a ", _jsx(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: _jsx(_components.code, {
          children: "--filter"
        })
      }), " to ensure those resources are available—and make sure everyone in the repo knows to use it."]
    }), "\n", _jsxs(_components.p, {
      children: ["Instead, we’re introducing the ", _jsx(_components.code, {
        children: "with"
      }), " key so you can guarantee that a dependent long-running task always runs ", _jsx(_components.em, {
        children: "with"
      }), " the long-running tasks that it depends on at runtime."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"with\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"api#start\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Using this ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "Package Configuration"
      }), ", anytime that the ", _jsx(_components.code, {
        children: "web"
      }), " application’s ", _jsx(_components.code, {
        children: "dev"
      }), " task is started, the ", _jsx(_components.code, {
        children: "api"
      }), "'s ", _jsx(_components.code, {
        children: "start"
      }), " task will also run using ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#depending-on-a-specific-task-in-a-specific-package",
        children: ["the ", _jsx(_components.code, {
          children: "package#task"
        }), " microsyntax"]
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/configuration#with",
        children: "Visit the documentation"
      }), " to learn more."]
    }), "\n", _jsxs(_components.h2, {
      id: "improved-control-for---continue-behavior",
      children: ["Improved control for ", _jsx(_components.code, {
        children: "--continue"
      }), " behavior"]
    }), "\n", _jsxs(_components.p, {
      children: ["By default, Turborepo stops running tasks when it encounters a task that has failed. You can alter this behavior using the ", _jsx(_components.code, {
        children: "--continue"
      }), " flag, instructing Turborepo to continue running tasks, even when one or more tasks have failed."]
    }), "\n", _jsxs(_components.p, {
      children: ["While the ", _jsx(_components.code, {
        children: "--continue"
      }), " flag is useful, there are times when running tasks whose dependencies have failed will only result in more failures. For these situations, we’ve added a new value to the ", _jsx(_components.code, {
        children: "--continue"
      }), " flag in this release: ", _jsx(_components.code, {
        children: "--continue=dependencies-successful"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --continue=dependencies-successful"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "When using this value, all dependencies for a task must be successful for the dependent task to run."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/run#--continueoption",
        children: "Learn more in the documentation"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "The Turborepo core team would like to thank @jenseng for contributing this feature."
    }), "\n", _jsx(_components.h2, {
      id: "add-comments-to-your-turborepo-configuration-files",
      children: "Add comments to your Turborepo configuration files"
    }), "\n", _jsxs(_components.p, {
      children: ["You can now use JSONC (", _jsx(_components.code, {
        children: "turbo.jsonc"
      }), ") for your configuration files, allowing you to add useful comments to your configuration."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.jsonc",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // Our tests need their dependencies to be built first"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "pruned-monorepos-for-bun-repositories",
      children: "Pruned monorepos for Bun repositories"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), " creates a partial monorepo for a target package, and is especially useful for ", _jsx(_components.a, {
        href: "/docs/guides/tools/docker",
        children: "creating lightweight Docker images from monorepos"
      }), ". This command has been available for pnpm, npm, and Yarn repositories in previous versions of Turborepo."]
    }), "\n", _jsxs(_components.p, {
      children: ["In this release, ", _jsx(_components.code, {
        children: "turbo prune"
      }), " is now available for Bun v1.2+, which has introduced a text-based lockfile that we can now read and analyze."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " prune"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more about ", _jsx(_components.code, {
        children: "turbo prune"
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/prune",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "The Turborepo core team would like to thank @camero2734 for contributing this feature."
    }), "\n", _jsxs(_components.h2, {
      id: "reference-your-workspace-root-with-the-turbo_root-microsyntax",
      children: ["Reference your workspace root with the ", _jsx(_components.code, {
        children: "$TURBO_ROOT$"
      }), " microsyntax"]
    }), "\n", _jsx(_components.p, {
      children: "In some situations, you’re forced to break out of package boundaries in a monorepo. This could be due to a number of constraints, like tooling that doesn’t conform to modern package manager workspaces or incremental migration workflows that take you out of ideal conditions."
    }), "\n", _jsxs(_components.p, {
      children: ["In the past, you’d need to write paths in ", _jsx(_components.code, {
        children: "turbo.json"
      }), " that traverse to the workspace root, since globs are anchored to the root of packages:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"../../important-file.txt\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "While this pattern does work, it can lead to inconsistencies in some cases:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Some packages may need ", _jsx(_components.code, {
          children: "../"
        }), " while others need ", _jsx(_components.code, {
          children: "../../"
        })]
      }), "\n", _jsx(_components.li, {
        children: "A developer could potentially move a package to a different location so that the path isn’t correct"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Instead, you can now use the ", _jsx(_components.code, {
        children: "$TURBO_ROOT$"
      }), " microsyntax:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_ROOT$/important-file.txt\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Now, this file glob is guaranteed to always start at the root of your workspace."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/configuration#turbo_root",
        children: "Visit the documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.h2, {
      id: "openapi-specification-viewer-for-self-hosting",
      children: "OpenAPI specification viewer for self-hosting"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo is proudly open-source with a public specification for its Remote Caching protocol. While ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache is a free-to-use managed option"
      }), ", the OpenAPI spec allows the community to create implementations for Remote Caching of their own."]
    }), "\n", _jsxs(_components.p, {
      children: ["We’ve published ", _jsx(_components.a, {
        href: "/api/remote-cache-spec",
        children: "the Remote Cache spec as JSON to the web"
      }), " for some time, and have recently added a human-friendly version of the spec at ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/openapi",
        children: "https://turborepo.com/docs/openapi"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching#remote-cache-api",
        children: "Visit the Remote Caching documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.h2, {
      id: "other-changes",
      children: "Other changes"
    }), "\n", _jsxs(Accordions, {
      children: [_jsx(Accordion, {
        title: "Features (9)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["feat(boundaries): package rules (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10160",
              children: "#10160"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): package name as tag punning (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10151",
              children: "#10151"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): implicit dependencies (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10117",
              children: "#10117"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(process): distinguish between signals used to kill children (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10049",
              children: "#10049"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): auto ignore (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10147",
              children: "#10147"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(clone): turbo clone (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9904",
              children: "#9904"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): support tsconfig path aliases (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10002",
              children: "#10002"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(query): add schema flag (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10052",
              children: "#10052"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(ls): add package path to ls (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10079",
              children: "#10079"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Fixes (19)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["fix(turbo_json): avoid workspace validation errors (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10211",
              children: "#10211"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(bun): deserialize correctly and use optionalPeers (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10219",
              children: "#10219"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: update env variables supported by nitro (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10176",
              children: "#10176"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: mark type of flat config export to satisfy Linter.Config[] (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10128",
              children: "#10128"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(eslint): array type lints (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10139",
              children: "#10139"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(bun): properly handle bun lockfile keys (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10137",
              children: "#10137"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: eslint-config-turbo module export (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10105",
              children: "#10105"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: correctly forward passthrough arguments when using pkg#task format (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10087",
              children: "#10087"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(boundaries): support import attributes (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10078",
              children: "#10078"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(boundaries): unnecessary tsconfig warnings (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10104",
              children: "#10104"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(affected): consider turbo.jsonc as a default global dependency (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10106",
              children: "#10106"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(prune): support copying turbo.jsonc (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10107",
              children: "#10107"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cli): no longer attempt to parse task name as continue value (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10097",
              children: "#10097"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: affected_packages's optimization flow (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9950",
              children: "#9950"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(@turbo/repository): revert \"chore(deps): update git2 to 0.20.0\" (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10045",
              children: "#10045"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(process): revert \"feat(process): differentiate between child interruption and killing\" (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10046",
              children: "#10046"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: filter logic (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9653",
              children: "#9653"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(packages): no longer match versionless packages (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10056",
              children: "#10056"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(engine): no longer error if provided task is omitted by filter (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10051",
              children: "#10051"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Documentation (33)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["docs: layout redesign (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10178",
              children: "#10178"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix text colors in a few spots (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10213",
              children: "#10213"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove stale callout (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10217",
              children: "#10217"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: links for OpenAPI spec for both human-readable and JSON (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10216",
              children: "#10216"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add a snippet to with (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10215",
              children: "#10215"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention JSONC support (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10214",
              children: "#10214"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix the incorrect export keyword (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10235",
              children: "#10235"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add checkout optimization for --affected (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10188",
              children: "#10188"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: use schema from current @turbo/types (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10197",
              children: "#10197"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: switch turbo run to turbo watch for --experimental-write-cache (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10199",
              children: "#10199"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(run): fix passthrough arg behavior (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10167",
              children: "#10167"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: bump openapi framework version (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10172",
              children: "#10172"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typos (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10182",
              children: "#10182"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update fallback OG image (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10174",
              children: "#10174"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: enhance examples tables (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10173",
              children: "#10173"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typos in documentation files (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10192",
              children: "#10192"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typos in documentation files (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10124",
              children: "#10124"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update storybook initiation instructions (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10145",
              children: "#10145"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: clarify TURBO_TEAM slug usage (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10102",
              children: "#10102"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: adds callout for installation instructions for PNPM (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10100",
              children: "#10100"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add release phases to support policy (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10091",
              children: "#10091"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove ls from Experimental phase in Support Policy (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10108",
              children: "#10108"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix code black background colors (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10141",
              children: "#10141"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): prefix environment variable for search dialog (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10142",
              children: "#10142"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): fix commas in package exports example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10143",
              children: "#10143"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: open source site source code (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10127",
              children: "#10127"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove experimental warning from ls command (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10096",
              children: "#10096"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add hybrid approach to vitest guide (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10092",
              children: "#10092"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typo on continue docs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10041",
              children: "#10041"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add explicit mention for capturing multiple .env files (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10061",
              children: "#10061"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix json title for Watch Mode docs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10085",
              children: "#10085"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: upgrades for Vitest doc and add with-vitest example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10063",
              children: "#10063"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): asset importing failure for OG images (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10159",
              children: "#10159"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Examples (5)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["fix: unexpected top-level property default in base.js eslint config (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10240",
              children: "#10240"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(example): remove obsolete @types/react-native from with-react-native-web (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10190",
              children: "#10190"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update README.md in examples with-tailwind to correctly reference .ts config files instead of .js (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10057",
              children: "#10057"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix JSDoc annotation for ESLint flat configs of basic example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10089",
              children: "#10089"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(examples): add example with-solid (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10144",
              children: "#10144"
            }), ")"]
          }), "\n"]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "acknowledgments-and-community",
      children: "Acknowledgments and community"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo is the result of the combined work of all of its contributors, including our core team: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/dimitropoulos",
        children: "Dimitri"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", and ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice. To learn how to get involved, ", _jsx(_components.a, {
        href: "/docs/community",
        children: "visit the Community page"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "We also thank everyone who contributed to this release of Turborepo: @beaussan, @bohongu, @camero2734, @cprussin, @dinglindong, @jenseng, @jimmycathy, @kevincatty, @mm-webx, @ognevny, @pi0, @pudongair, @rootdiae, @shinjith-dev, @sicarius97, @ssshashank, @Tigatok, @todaymoon, @Tyoneb, @victorlagerfors, @vinayaksodar, @wmjae, @x-N0, and @xiaobei0715."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
